import axios from 'axios';
import { useMutation } from 'react-query';

// https://bluedot3562.zendesk.com/api/v2/tickets.json
export const sendZendeskTicket = async body => {
  try {
    const data = await axios.post('/api/send-zd-ticket', body);
    console.log(data);
  } catch (e) {
    console.log(e);
  }
};

export const useSendZendiskTicketMutation = () => {
  return useMutation({
    mutationFn: ({
      name,
      email,
      contact,
      company,
      queryKind,
      message,
    }: {
      name: string;
      email: string;
      contact: string;
      company: string;
      queryKind: string;
      message: string;
    }) => {
      const labels = {
        Purchase: '구매',
        'Technical Inquiry': '기술문의',
        'Product Inquiry': '제품 문의',
        'Request AVIF Demo': 'AVIF 데모 요청',
        Other: '기타',
      };

      return sendZendeskTicket({
        ticket: {
          subject: `[${
            labels[queryKind] || queryKind
          }] | [${company}] 로 부터 전송된 문의`,
          comment: {
            html_body: `<p><strong>Name</strong> : ${name}</p>
                        <p><strong>Email</strong> : ${email}</p>
                        <p><strong>Contact</strong> : ${contact || '-'}</p>
                        <p><strong>Company</strong> : ${company}</p>
                        <br />
                        <p><strong>Message</strong> : ${message}</p>`,
            public: true,
          },
          requester: {
            email,
            name,
          },
          custom_fields: [
            { id: '12234644768527', value: 'homepage' }, // zendesk 티켓 내 'chat_entry_point' 필드
            { id: '12276217298831', value: 'email' }, // zendesk 티켓 내 'chat_entry_type' 필드
          ],
          assignee_email: 'sales@blue-dot.io',
        },
      });
    },
  });
};
